module.exports = __webpack_public_path__ + "static/media/4.9fbf9ad3.png";